import { DepartamentoReadingDtoProps } from "./DTOs/DepartamentoReadingDto"
import { DepartamentoReadingFiltersDtoProps } from "./DTOs/DepartamentoReadingFiltersDto"

export const DepartamentoReadingFiltersAdapter = (
  departamento: DepartamentoReadingFiltersDtoProps
): DepartamentoReadingFiltersDtoProps => ({
  id: departamento.id,
  nombre: departamento.nombre,
  numeroUsuarios: departamento.numeroUsuarios,
  responsableNombres: departamento.responsableNombres,
})

export const DepartamentoReadingByIdAdapter = (
  departamento: DepartamentoReadingDtoProps
): DepartamentoReadingDtoProps => ({
  id: departamento.id,
  nombre: departamento.nombre,
  responsableIds: departamento.responsableIds,
})
